export const GREET_VIEWED = 'Greet Viewed';
export const GREET_SHARED = 'Share Modal Opened';
export const GREET_REPLIED = 'Greet Replied';
export const GREET_REACTED = 'Greet Reacted';

export enum GreetEventContext {
  LandingPage = 'landing_page',
  Widget = 'widget',
  Email = 'email',
}
